import { PROMO_CODE_PRE, PROMO_CODE_POS } from '../constants/Plans'
import * as contentful from 'contentful'

let env = process.env.NODE_ENV

let CHECK_CODE = 'https://middleware.veloe.com.br/publico/campanhas'
let FC_FLOW_PRE_URL = 'https://veloe.com.br/planos/total-pre'
let FC_FLOW_POS_URL = 'https://veloe.com.br/planos/total-pos'
let WHITELIST_URL = 'https://middleware.veloe.com.br/publico/whitelist'

if (window.location.href) {
  if (window.location.href.indexOf('localhost') > -1) env = 'local'
  else if(window.location.href.indexOf('hml') > -1) env = 'hml'
  else if (window.location.href.indexOf('dev') > -1) env = 'dev'
}

if (env === 'local') {
  CHECK_CODE = 'http://localhost:3001/publico/campanhas'
  FC_FLOW_PRE_URL = 'http://localhost:3000/planos/total-pre'
  FC_FLOW_POS_URL = 'http://localhost:3000/planos/total-pos'
  WHITELIST_URL = 'http://localhost:3001/publico/whitelist'
}
else if (env === 'dev') {
  CHECK_CODE = 'http://localhost:3001/publico/campanhas'
  FC_FLOW_PRE_URL = 'http://localhost:3000/planos/total-pre'
  FC_FLOW_POS_URL = 'http://localhost:3000/planos/total-pos'
  WHITELIST_URL = 'http://localhost:3001/publico/whitelist'
} else if (env === 'hml') {
  CHECK_CODE = 'https://middleware.hml.fastalelo.com/publico/campanhas'
  FC_FLOW_PRE_URL = 'https://hml.fastalelo.com/planos/total-pre'
  FC_FLOW_POS_URL = 'https://hml.fastalelo.com/planos/total-pos'
  WHITELIST_URL = 'https://hml.fastalelo.com/publico/whitelist'
}

export {
  CHECK_CODE,
  FC_FLOW_PRE_URL,
  FC_FLOW_POS_URL,
  WHITELIST_URL,
}
export const client = contentful.createClient({
  space: '486fbuk7vhzs',
  accessToken: 'ef73aac58d415790712277bef9edecfe0c0518ed56c3203202fbfafaeae2eb6b'
})

export const getPlanPre = () => fetch(`${CHECK_CODE}/${PROMO_CODE_PRE}`)
  .then(res => res.json())
  .catch(e => null)

export const getPlanPos = () => fetch(`${CHECK_CODE}/${PROMO_CODE_POS}`)
  .then(res => res.json())
  .catch(e => null)

  